import { PayloadAction } from '@reduxjs/toolkit'
import { VisitorSliceState } from 'src/core/models'


const reducers = {
  setCookiesLoading: (state: VisitorSliceState, action: PayloadAction<boolean>) => {
    state.cookies.loading = action.payload
  },
}

export default reducers
